import React, { useEffect, useState, useRef } from 'react'
import Alert from '@zera-admin/alert'
import Icon from '@zera-admin/icon'

import { useFlagcard, FlagcardData } from 'app/contexts/flagcard'

import * as Styled from './FlagcardItem.styled'
import { getDictionaryValue } from 'app/functions/path'
import CustomButton from 'components/customButton'

const FlagcardItem: React.FunctionComponent<FlagcardData> = ({
  children,
  id,
  ...rest
}) => {
  const [countdown, setCountdown] = useState(7)
  const timerRef = useRef<NodeJS.Timer>()
  const [flagcard] = useFlagcard()

  const setTimer = () => {
    timerRef.current = setInterval(() => {
      setCountdown((countdown) => countdown - 1)
    }, 1000)
  }

  const clearTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current)
    }
  }

  useEffect(() => {
    setTimer()

    return function cleanup() {
      clearTimer()
    }
  }, [])

  useEffect(() => {
    if (countdown === 0) {
      clearTimer()

      if (id) {
        flagcard.remove(id)
      }
    }
  }, [flagcard, countdown, id])

  useEffect(() => {
    if (rest.appearance === 'success') {
      setCountdown(1)
    } else {
      setCountdown(8)
    }
  }, [rest.appearance])

  return (
    <Styled.Root>
      <Styled.Capsule onMouseEnter={clearTimer} onMouseLeave={setTimer}>
        <Alert {...rest}>
          <p>{children}</p>
        </Alert>
        <button
          onClick={() => setCountdown(0)}
          style={{
            cursor: 'pointer',
            color: '#d84027',
            border: 'none',
            background: 'none',
            width: 'fit-content',
            height: 'fit-content',
            zIndex: 9999999,
          }}
        >
          <Icon size="small" name="cross-circle" />
        </button>
      </Styled.Capsule>
      <Styled.Countdown>
        {countdown + ' ' + getDictionaryValue('flagcardcoundown')}
      </Styled.Countdown>
    </Styled.Root>
  )
}

export default FlagcardItem
